import { getImportSummaryErrors, getImportSummaryData, importSummary } from '@api/onboarding';
import { useMutation, useQuery } from '@tanstack/react-query';
import { OnboardingStep } from '@interfaces/models';
import { useNavigate } from 'react-router-dom';
import { downloadFile } from '@helpers/utils';
import { Routes } from '@shared/enums';
import { DateTime } from 'luxon';

export const useOnboardingImportSummary = () => {
  const errorFileName = `SkyCash_import_error_log_${DateTime.now().toFormat('ddLLyyyy')}.csv`;
  const navigate = useNavigate();

  const sendImportMutation = useMutation({
    mutationFn: () => {
      return importSummary(OnboardingStep.IMPORT_VEHICLES);
    },
    onSuccess: () => {
      navigate(`../${Routes.IMPORT_VEHICLES}`);
    },
  });

  const getErrorsMutation = useMutation({
    mutationFn: getImportSummaryErrors,
    onSuccess: (file) => downloadFile(file, errorFileName),
  });

  const { data: importSummaryData, isLoading: isQueryLoading } = useQuery({
    queryKey: ['onboarding', 'import-summary'],
    queryFn: getImportSummaryData,
  });

  return {
    isGetErrorsLoading: getErrorsMutation.isPending,
    isSaveLoading: sendImportMutation.isPending,
    onGetErrors: getErrorsMutation.mutate,
    onSave: sendImportMutation.mutate,
    importSummaryData,
    isQueryLoading,
  };
};
